module.exports = __webpack_public_path__ + "img/20220624162610.b9a73926.png";